import { Divider, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import { MonthMap } from '../../../core-utils/helper-utils/EditDuration';
import moment from 'moment';

export interface CustomDateMonthGridProps {
  currentYear: string;
  yearArray: string[];
  yearIndex?: number;
  currentMonth: string;
  monthArray?: string[];
  handleChange: any;
  isYearGrid?: boolean;
  handleYearChange: any;
  currentDate: moment.Moment;
  setAnchorElement?: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
}

const CustomDateMonthGrid: React.FC<CustomDateMonthGridProps> = ({
  yearArray,
  yearIndex,
  monthArray,
  currentYear,
  currentMonth,
  handleChange,
  isYearGrid,
  handleYearChange,
  currentDate,
  setAnchorElement,
}) => {
  // styles
  const useStyles = makeStyles()({
    monthYearGrid: {
      boxSizing: 'border-box',
      width: '193px',
      background: '#FFFFFF',
      border: '1px solid #E5E9F0',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
      borderRadius: '4px',
      padding: '14px 0px 0px 14px',
      display: 'flex',
      maxHeight: '156px',
      overflowY: 'auto',
      ...scrollBarStyles,
    },
    monthYearItem: {
      height: '22px',
      width: '45px',
      fontSize: '12px',
      lineHeight: '20px',

      marginRight: '13px',
      marginBottom: '13px',
      textAlign: 'center',

      borderRadius: '4px',
      cursor: 'pointer',
    },
  });

  const { classes } = useStyles();

  return (
    <Grid
      container
      style={{
        boxSizing: 'border-box',
        width: '193px',
        background: '#FFFFFF',
        border: '1px solid #E5E9F0',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
        borderRadius: '4px',
      }}
    >
      <Grid
        style={{
          padding: '12px',
          display: 'flex',
          justifyContent: isYearGrid ? 'center' : 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        {isYearGrid ? (
          MonthMap.get(currentMonth)?.fullName
        ) : (
          <>
            <ChevronLeft
              style={{
                width: 'fit-content',
                color:
                  yearIndex === 0
                    ? 'rgba(0, 0, 0, 0.26)'
                    : patientAccessTheme.palette.status.icon,
                cursor: yearIndex === 0 ? 'default' : 'pointer',
              }}
              onClick={() => {
                handleYearChange(false, yearArray.length);
              }}
            />
            <Typography
              fontSize="12px"
              lineHeight="12px"
              textColor={patientAccessTheme.palette.text.highemphasis}
              fontType="semiBold"
            >
              {currentYear}
            </Typography>
            <ChevronRight
              style={{
                width: 'fit-content',
                color:
                  yearIndex === yearArray.length - 1
                    ? 'rgba(0, 0, 0, 0.26)'
                    : patientAccessTheme.palette.status.icon,
                cursor:
                  yearIndex === yearArray.length - 1 ? 'default' : 'pointer',
              }}
              onClick={() => {
                handleYearChange(true, yearArray.length);
              }}
            />
          </>
        )}
      </Grid>
      <Divider />
      <Grid container className={classes.monthYearGrid}>
        {isYearGrid
          ? yearArray.map((yearItem: string, index: number) => (
              <div
                key={index}
                className={classes.monthYearItem}
                style={{
                  color:
                    yearItem === currentYear
                      ? patientAccessTheme.palette.status.white
                      : patientAccessTheme.palette.text.mediumemphasis,
                  backgroundColor:
                    yearItem === currentYear
                      ? patientAccessTheme.palette.primary[400]
                      : patientAccessTheme.palette.status.white,
                }}
                onClick={() => handleChange(yearItem)}
              >
                {yearItem}
              </div>
            ))
          : monthArray?.map((monthItem: string, index: number) => (
              <div
                key={index}
                className={classes.monthYearItem}
                style={{
                  color:
                    monthItem === currentMonth &&
                    currentYear === currentDate.format('YYYY')
                      ? patientAccessTheme.palette.status.white
                      : patientAccessTheme.palette.text.mediumemphasis,
                  backgroundColor:
                    monthItem === currentMonth &&
                    currentYear === currentDate.format('YYYY')
                      ? patientAccessTheme.palette.primary[400]
                      : patientAccessTheme.palette.status.white,
                }}
                onClick={() => {
                  if (setAnchorElement) {
                    setAnchorElement(null);
                  }
                  handleChange(monthItem);
                }}
              >
                {monthItem}
              </div>
            ))}
      </Grid>
    </Grid>
  );
};

export default CustomDateMonthGrid;
